// extracted by mini-css-extract-plugin
export var actionButton = "_ki-t";
export var buttonContainer = "_ki-0";
export var buttonContainer2 = "_ki-1";
export var buttonSection = "_ki-2";
export var details = "_ki-3";
export var dropdownItem = "_ki-5";
export var dropdownItemsContainer = "_ki-4";
export var fileInput = "_ki-r";
export var headerButton = "_ki-6";
export var icon = "_ki-7";
export var input = "_ki-8";
export var macroListItem = "_ki-9";
export var mainContent = "_ki-a";
export var microText = "_ki-b";
export var modal = "_ki-w";
export var optionsButton = "_ki-c";
export var paperclip = "_ki-s";
export var pillContent = "_ki-d";
export var preview = "_ki-e";
export var preview2 = "_ki-f";
export var quillEditor = "_ki-q";
export var selectedMacro = "_ki-g";
export var sidebar = "_ki-h";
export var sidebarHeader = "_ki-j";
export var sidebarList = "_ki-i";
export var sidebarListItem = "_ki-k";
export var sidebarSearch = "_ki-l";
export var snoozeDurationWrapper = "_ki-v";
export var statusPillContainer = "_ki-m";
export var tagsContainer = "_ki-n";
export var unselectedMacro = "_ki-o";
export var variable = "_ki-u";
export var wrapper = "_ki-p";